import React from 'react';

export const ConceptDiagram = ({ type = 'operating-system', className = '' }) => {
  const diagrams = {
    'operating-system': (
      <svg viewBox="0 0 120 120" className="w-full h-full" fill="none">
        <circle cx="60" cy="60" r="50" stroke="#5a7fa8" strokeWidth="0.5" strokeDasharray="4 2" className="animate-[rotate-slow_60s_linear_infinite]" style={{ transformOrigin: 'center' }} />
        <circle cx="60" cy="60" r="35" stroke="#5a7fa8" strokeWidth="0.5" />
        <circle cx="60" cy="60" r="20" stroke="#c9a87c" strokeWidth="1" className="breathe" />
        <circle cx="60" cy="60" r="5" fill="#c9a87c" />
        <line x1="60" y1="10" x2="60" y2="40" stroke="#5a7fa8" strokeWidth="0.5" opacity="0.5" />
        <line x1="60" y1="80" x2="60" y2="110" stroke="#5a7fa8" strokeWidth="0.5" opacity="0.5" />
        <line x1="10" y1="60" x2="40" y2="60" stroke="#5a7fa8" strokeWidth="0.5" opacity="0.5" />
        <line x1="80" y1="60" x2="110" y2="60" stroke="#5a7fa8" strokeWidth="0.5" opacity="0.5" />
      </svg>
    ),
    'pattern-mind': (
      <svg viewBox="0 0 120 120" className="w-full h-full" fill="none">
        <rect x="30" y="30" width="60" height="60" stroke="#5a7fa8" strokeWidth="0.5" fill="none" />
        <rect x="40" y="40" width="40" height="40" stroke="#5a7fa8" strokeWidth="0.5" fill="none" transform="rotate(15 60 60)" className="float-slow" style={{ transformOrigin: 'center' }} />
        <rect x="45" y="45" width="30" height="30" stroke="#c9a87c" strokeWidth="1" fill="none" transform="rotate(-10 60 60)" />
        <line x1="20" y1="20" x2="40" y2="40" stroke="#5a7fa8" strokeWidth="0.5" opacity="0.3" />
        <line x1="100" y1="20" x2="80" y2="40" stroke="#5a7fa8" strokeWidth="0.5" opacity="0.3" />
        <line x1="20" y1="100" x2="40" y2="80" stroke="#5a7fa8" strokeWidth="0.5" opacity="0.3" />
        <line x1="100" y1="100" x2="80" y2="80" stroke="#5a7fa8" strokeWidth="0.5" opacity="0.3" />
        <circle cx="60" cy="60" r="4" fill="#c9a87c" className="breathe" />
      </svg>
    ),
    'thought-code': (
      <svg viewBox="0 0 120 120" className="w-full h-full" fill="none">
        <line x1="20" y1="30" x2="100" y2="30" stroke="#5a7fa8" strokeWidth="0.5" />
        <line x1="20" y1="50" x2="80" y2="50" stroke="#5a7fa8" strokeWidth="0.5" />
        <line x1="20" y1="70" x2="90" y2="70" stroke="#c9a87c" strokeWidth="1" className="float-slow" style={{ transformOrigin: 'left center' }} />
        <line x1="20" y1="90" x2="70" y2="90" stroke="#5a7fa8" strokeWidth="0.5" />
        <circle cx="15" cy="30" r="2" fill="#5a7fa8" />
        <circle cx="15" cy="50" r="2" fill="#5a7fa8" />
        <circle cx="15" cy="70" r="3" fill="#c9a87c" className="breathe" />
        <circle cx="15" cy="90" r="2" fill="#5a7fa8" />
        <rect x="85" y="65" width="20" height="10" stroke="#c9a87c" strokeWidth="0.5" fill="none" />
      </svg>
    ),
    'presence-architecture': (
      <svg viewBox="0 0 120 120" className="w-full h-full" fill="none">
        <polygon points="60,15 100,45 100,90 60,105 20,90 20,45" stroke="#5a7fa8" strokeWidth="0.5" fill="none" />
        <polygon points="60,30 85,50 85,80 60,92 35,80 35,50" stroke="#5a7fa8" strokeWidth="0.5" fill="none" className="float-slow" style={{ transformOrigin: 'center' }} />
        <polygon points="60,42 72,52 72,70 60,78 48,70 48,52" stroke="#c9a87c" strokeWidth="1" fill="none" />
        <circle cx="60" cy="60" r="5" fill="#c9a87c" className="breathe" />
        <line x1="60" y1="15" x2="60" y2="42" stroke="#5a7fa8" strokeWidth="0.3" opacity="0.5" />
        <line x1="20" y1="45" x2="48" y2="52" stroke="#5a7fa8" strokeWidth="0.3" opacity="0.5" />
        <line x1="100" y1="45" x2="72" y2="52" stroke="#5a7fa8" strokeWidth="0.3" opacity="0.5" />
      </svg>
    ),
  };

  return (
    <div className={`${className}`}>
      {diagrams[type]}
    </div>
  );
};

export default ConceptDiagram;
